import { render, staticRenderFns } from "./EvaluateTabel.vue?vue&type=template&id=3ccfc590&scoped=true"
import script from "./EvaluateTabel.vue?vue&type=script&lang=js"
export * from "./EvaluateTabel.vue?vue&type=script&lang=js"
import style0 from "./EvaluateTabel.vue?vue&type=style&index=0&id=3ccfc590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ccfc590",
  null
  
)

export default component.exports